/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Fast: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19.207 15.207L13.207 21.207L11.793 19.793L17.793 13.793L19.207 15.207ZM9.70703 16.707L5.70703 20.707L4.29297 19.293L8.29297 15.293L9.70703 16.707ZM11.207 7.20703L3.20703 15.207L1.79297 13.793L9.79297 5.79297L11.207 7.20703ZM21 3C21.5523 3 22 3.44772 22 4V10.5H20V6.41406L11.707 14.707L10.293 13.293L18.5859 5H14.5V3H21Z'
      fill='currentColor'
    />
  </React.Fragment>
)
